<template>
  <div class="body">
    <div class="tabs">
      <div>
        <div :class="{'is-active':curP==0}" @click="doCheck(0)">首页</div>
        <div :class="{'is-active':curP==1}" @click="doCheck(1)">样线制作</div>
        <div :class="{'is-active':curP==2}" @click="doCheck(2)">PCBA加工</div>
        <div :class="{'is-active':curP==3}" @click="doCheck(3)">连接器定制</div>
        <div :class="{'is-active':curP==4}" @click="doCheck(4)">主要产品</div>
        <div :class="{'is-active':curP==5}" @click="doCheck(5)">公司简介</div>
      </div>
      <div></div>
      <div class="tab_bar" id="tab_bar"></div>
    </div>
    <div class="test">
      <router-view />
    </div>
    <div class="hr"></div>
    <v-footer></v-footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curP: 1
    };
  },
  mounted() {
    var curP = this.$route.query.curP;
    this.curP = curP;
    console.log(this.curP)
    this.doCheck(this.curP)
  },
  methods: {
    doCheck(i) {
      this.curP = i;
      var tab_bar = document.getElementById("tab_bar");
      if (i == 0) {
        tab_bar.style = "width:24px;transform:translateX(8px)";
        this.goIndex();
      } else if (i == 1) {
        tab_bar.style = "width:48px;transform:translateX(175px)";
        this.goJC();
      } else if (i == 2) {
        tab_bar.style = "width:48px;transform:translateX(381px)";
        this.goNB();
      } else if (i == 3) {
        tab_bar.style = "width:48px;transform:translateX(595px)";
        this.goUPR();
      } else if (i == 4) {
        tab_bar.style = "width:48px;transform:translateX(804px)";
        this.goPro();
      } else if (i == 5) {
        tab_bar.style = "width:48px;transform:translateX(1001px)";
        this.goCallMe();
      }
    },
    goIndex() {
      this.$router.push("/");
    },
    goJC() {
      this.$router.push("/Home/JC");
    },
    goNB() {
      this.$router.push("/Home/NB");
    },
    goUPR() {
      this.$router.push("/Home/UPR");
    },
    goPro() {
      this.$router.push("/Home/Product");
    },
    goCallMe() {
      this.$router.push("/Home/CallMe");
    }
  }
};
</script>

<style scoped>
.body {
  width: 1064px;
  margin: 0 auto;
}
.tabs {
  width: 1064px;
}
.tabs > div:first-child {
  color: #000;
}
.tabs > div:nth-child(2) {
  background-color: #fff;
}
.tabs .tab_bar {
  background-color: #000;
}
/* 分割线 */
.hr {
  width: 1065px;
  height: 1px;
  margin: 0 auto;
  background: #c6c6c6;
  margin-top: 62px;
}
</style>